import React, { useState, useEffect, useContext } from 'react'
import { GeneralContext } from '../../context/'
import ApiService from '../../data/services/ApiService'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Breadcrumbs from '../../components/Global/Breadcrumbs'

import {
    Row,
    Col,
    Card,
    CardTitle,
    CardBody,
    FormGroup,
    Container,
    Label,
    Input,
    Button
} from "reactstrap"

const Index = () => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [clave, setClave] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [patentes, setPatentes] = useState([])

    useEffect(() => {
        (async () => {
            await fetchPatentes()
        })()

        // eslint-disable-next-line
    }, [])

    const _addItem = async (e) => {
        e.preventDefault()

        if (clave.trim() === '') {
            toastr.error('Agrega la clave de patente', 'Error')
            return
        }

        try {
            setLoading(true)
            const response = await ApiService.createPatente({
                clave: clave.trim(),
                descripcion: descripcion.trim()
            })

            window.analytics.track('Patente Agregada')
            toastr.success(response.data.message, '¡Chócalas!')
            setClave('')
            setDescripcion('')
            fetchPatentes()
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const _deleteItem = async (id) => {
        try {
            setLoading(true)
            const response = await ApiService.deletePatente(id)

            const filtered = patentes.filter((v) => v._id !== id)
            setPatentes(filtered)

            window.analytics.track('Patente Eliminada')
            toastr.success(response.data.message, '¡Chócalas!')
        } catch(error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchPatentes = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getPatentes()
            const { data } = response.data

            setPatentes(data)
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <div id="mainContent" className="page mainContent">
                <Container fluid>
                    <Breadcrumbs
                        title="Configuraciones"
                        breadcrumbItem={`Patentes Aduanales`}
                        parentLink={`/configuracion/patentes`}
                    />

                    <Card>
                        <CardTitle>Agrega las patentes aduanales que utilizas con mayor frecuencia en tus operaciones.</CardTitle>

                        <CardBody>
                            <form onSubmit={_addItem}>
                                <Row>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label>Clave</Label>
                                            <Input
                                                value={clave}
                                                maxLength={4}
                                                placeholder="3456"
                                                onChange={(e) => setClave(e.target.value.replace(/\D/g, '').slice(0, 4))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={7}>
                                        <FormGroup>
                                            <Label>Descripcion</Label>
                                            <Input
                                                value={descripcion}
                                                placeholder="Nombre o referencia de la patente"
                                                onChange={(e) => setDescripcion(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={2} className="d-flex align-items-end">
                                        <Button type="submit" color="success" className="mb-3 w-100">
                                            Guardar
                                        </Button>
                                    </Col>
                                </Row>
                            </form>
                        </CardBody>
                    </Card>

                    <Card>
                        <CardTitle>Mi Catalogo</CardTitle>

                        <CardBody>
                            <ul className='unidades_list'>
                                {patentes && patentes.map((item, key) => {
                                    return (
                                        <li key={key}>
                                            <span>
                                                <button className="btn btn-danger" type="button" onClick={() => _deleteItem(item._id)}>
                                                    <i className='mdi mdi-trash-can'></i>
                                                </button> ({item.clave}) {item.descripcion}
                                            </span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Index
